import {
  Component,
  ViewChild,
  TemplateRef,
  AfterViewInit,
  ChangeDetectorRef,
  ElementRef,
  OnDestroy,
} from "@angular/core";
import { MatRowDef, MatTableModule } from "@angular/material/table";
import { MatDialogModule, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { CommonModule, NgIf } from "@angular/common";
import { MatButtonModule } from "@angular/material/button";
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from "@angular/forms";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import {
  MatPaginator,
  MatPaginatorIntl,
  MatPaginatorModule,
  PageEvent,
} from "@angular/material/paginator";
import { MatSort, MatSortModule } from "@angular/material/sort";
import { MatSelectModule } from "@angular/material/select";
import { MatIcon, MatIconModule } from "@angular/material/icon";
import { MatSlideToggle } from "@angular/material/slide-toggle";
import { MatOptionModule } from "@angular/material/core";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatSnackBar } from "@angular/material/snack-bar";
import { CompanyService } from "../../configuration/company/company.service.service";
import { MatSidenav, MatSidenavContainer } from "@angular/material/sidenav";
import { MatMenuModule } from "@angular/material/menu";
import { MatTabsModule } from "@angular/material/tabs";
import {
  NgLabelTemplateDirective,
  NgOptionTemplateDirective,
  NgSelectComponent,
  NgSelectModule,
} from "@ng-select/ng-select";
import { CustomMatPaginatorIntl } from "app/mock-api/common/customPaginatorIntl";
import {
  ApplicationsAttributes,
  CompanyAttributes,
  DocumentClassAttributes,
  DocumentDetailClassAttributes,
  DocumentTypeAttributes,
  ExpeditionConditionAttributes,
  ShortSubApplicationsAttributes,
  SubApplicationsAttributes,
  SubRouteAttributes,
} from "@albatrosdeveloper/ave-models-package";
import { Subject, ReplaySubject, take, takeUntil, Subscription, firstValueFrom } from "rxjs";
import { ApplicationService } from "../applications/applications.service";
import { NgxMatSelectSearchModule } from "ngx-mat-select-search";
import { ICreateDocumentClass } from "./interfaces/create-document-class.interface";
import { DocumentClassService } from "./document-class.service";
import { IUpdateDocumentClass } from "./interfaces/update-document-class.interface";
import PaymentConditionAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/masters/payment-condition/payment-condition.entity";
import { PaymentConditionService } from "../../master/payment-condition/payment-condition.service";
import { DocumentTypeService } from "../document-type/document-type.service";
import { ExpeditionConditionService } from "../../master/expedition-condition/expedition-condition.service";
import { OrdersCreationService } from 'app/modules/components/sales/order-generate/order-generate.service';
import { KeepQuotedEnum } from "@albatrosdeveloper/ave-models-package/lib/schemas/documents/document-class/enums/keep-quoted.enum"
import { MaterialBundlesBehaviourEnum } from "@albatrosdeveloper/ave-models-package/lib/schemas/documents/document-class/enums/material-bundle-behaviour.enum"
import { ActionRequirementEnum } from "@albatrosdeveloper/ave-models-package/lib/schemas/documents/document-class/enums/action-requirement.enum"
import { ActionApplicationEnum } from "@albatrosdeveloper/ave-models-package/lib/schemas/documents/document-class/enums/action-application.enum";
import RouteGroupAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/routing/route-group/route-group.entity";
import { SubRouteService } from "../../routing/sub-routes/sub-route.service";
import { RouteGroupService } from "../../routing/route-group/route-group.service";
import { getCode } from "app/utils/method";
import { OverCreditLimitEnum } from '@albatrosdeveloper/ave-models-package/lib/enums/over-credit-limit.enum';
import { RecalculatePriceEnum } from '@albatrosdeveloper/ave-models-package/lib/enums/recalculate-price.enum';
import { SearchService } from "app/layout/common/search-page/search-page.service";
import { StatusFiltersComponent } from "../../filters/status-filters/status-filters.component";
import { ConfigurationFiltersComponent } from "../../filters/configuration-filters/configuration-filters.component";
import { DocumentsFiltersComponent } from "../../filters/documents-filters/documents-filters.component";
import { FilterComponent } from "app/common/components/filter/filter.component";
import { HoverMenuDirective } from "@fuse/directives/hover-menu/hover-menu.directive";
import { ToggleOptionComponent } from "app/shared/components/form-ui/toggle-option/toggle-option.component";
import { FormSectionComponent } from "app/shared/components/form-ui/form-section/form-section.component";
import { materialInventoryToggles, salesMobile, salesMobileSectionCreate, salesMobileSectionUpdate, salesToggles } from "./document-class-toggle.config";
import SalesOfficeAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/configurations/sales-office/sales-office.entity";
import { SalesOfficeService } from "../../configuration/sales-office/sales-office.service";
import { IFilters } from "../../filters/interfaces/filterInterface";
import { IPaginationResult } from "app/common/interfaces/pagination-result.interface";
import { DocumentLineClassService } from "../document-class-line/document-class-line.service";
import { IPagination } from "app/common/interfaces/pagination.interface";


@Component({
  selector: "app-document-class",
  templateUrl: "./document-class.component.html",
  styleUrls: ["./document-class.component.scss"],
  standalone: true,
  imports: [
    CommonModule,
    MatTableModule,
    MatDialogModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSortModule,
    MatPaginatorModule,
    MatIcon,
    MatSlideToggle,
    MatSelectModule,
    MatOptionModule,
    MatTooltipModule,
    MatExpansionModule,
    MatMenuModule,
    MatButtonModule,
    MatIconModule,
    MatRowDef,
    MatSidenav,
    MatSidenavContainer,
    FormsModule,
    NgLabelTemplateDirective,
    NgOptionTemplateDirective,
    NgSelectComponent,
    NgSelectModule,
    MatTabsModule,
    NgxMatSelectSearchModule,
    StatusFiltersComponent,
    ConfigurationFiltersComponent,
    DocumentsFiltersComponent,
    FilterComponent,
    HoverMenuDirective,
    ToggleOptionComponent,
    FormSectionComponent
  ],
  providers: [{ provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntl }],
})
export class DocumentClassComponent implements AfterViewInit, OnDestroy {
  getCode = getCode;
  displayedColumns: string[] = [
    //"position", 
    "name", "documentType", "status", "actions"];
  currentCreateDocumentClass: ICreateDocumentClass =
    this.initializeCreateDocumentClass();
  currentUpdateDocumentClass: DocumentClassAttributes | undefined;

  dataSource: DocumentClassAttributes[] = [];
  companyList: CompanyAttributes[] = [];
  documentTypeList: DocumentTypeAttributes[] = [];
  expeditionConditionList: ExpeditionConditionAttributes[] = [];
  paymentConditionList: PaymentConditionAttributes[] = [];
  documentList: DocumentClassAttributes[] = [];
  selectedCompanyIds: string[] = [];
  applicationList: any[] = []

  quotedList: number[] = Object.values(KeepQuotedEnum).filter((value): value is number => typeof value === 'number');
  bundlesList: number[] = Object.values(MaterialBundlesBehaviourEnum).filter((value): value is number => typeof value === 'number');
  overCreditLimitList: number[] = Object.values(OverCreditLimitEnum).filter((value): value is number => typeof value === 'number');
  overOrderInvoiceList: number[] = Object.values(OverCreditLimitEnum).filter((value): value is number => typeof value === 'number');
  recalcPriceList: number[] = Object.values(RecalculatePriceEnum).filter((value): value is number => typeof value === 'number');

  searchQuery: string = "";
  totalItems: number = 0;
  pageSize: number = 50;
  pageIndex: number = 0;

  dialogRefAdd: MatDialogRef<any>;
  dialogRefEdit: MatDialogRef<any>;
  id: boolean = false;

  @ViewChild("editModal") editModal!: TemplateRef<any>;
  @ViewChild("addModal") addModal!: TemplateRef<any>;
  @ViewChild("deleteDialog") deleteDialog!: TemplateRef<any>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild("searchInput") searchInput!: ElementRef;

  salesToggles = salesToggles;
  materialInventoryToggles = materialInventoryToggles;
  salesMobile = salesMobile;
  salesMobileSectionCreate = salesMobileSectionCreate;
  salesMobileSectionUpdate = salesMobileSectionUpdate;

  protected _onDestroy = new Subject<void>();

  /** control for the selected application for multi-selection */
  public companyMultiCtrl: FormControl<CompanyAttributes[]> = new FormControl<
    CompanyAttributes[]
  >([]);

  /** control for the MatSelect filter keyword multi-selection */
  public companyMultiFilterCtrl: FormControl<string> = new FormControl<string>(
    ""
  );

  /** list of application filtered by search keyword */
  public filteredCompany: ReplaySubject<CompanyAttributes[]> =
    new ReplaySubject<CompanyAttributes[]>(1);

  /** local copy of filtered companies to help set the toggle all checkbox state */
  protected filteredCompanyCache: CompanyAttributes[] = [];

  /** flags to set the toggle all checkbox state */
  isIndeterminate = false;
  isChecked = false;

  /** control for the selected application for multi-selection */
  public documentMultiCtrl: FormControl<DocumentClassAttributes[]> =
    new FormControl<DocumentClassAttributes[]>([]);

  /** control for the MatSelect filter keyword multi-selection */
  public documentMultiFilterCtrl: FormControl<string> = new FormControl<string>(
    ""
  );

  /** list of application filtered by search keyword */
  public filteredDocument: ReplaySubject<DocumentClassAttributes[]> =
    new ReplaySubject<DocumentClassAttributes[]>(1);

  /** local copy of filtered companies to help set the toggle all checkbox state */
  protected filteredDocumentCache: DocumentClassAttributes[] = [];

  /** flags to set the toggle all checkbox state */
  isIndeterminateDoc = false;
  isCheckedDoc = false;

  /** control for the selected sub for multi-selection */
  //public subMultiCtrl: FormControl<SubApplicationsAttributes[]> = new FormControl<SubApplicationsAttributes[]>([]);
  public subMultiCtrl = new FormControl([])
  
  allowedLineClassesCtrl = new FormControl<string[]>([]);
  /** control for the MatSelect filter keyword multi-selection */
  public subMultiFilterCtrl: FormControl<string> = new FormControl<string>("");

  /** list of application filtered by search keyword */
  public filteredSub: ReplaySubject<SubApplicationsAttributes[]> =
    new ReplaySubject<SubApplicationsAttributes[]>(1);

  /** local copy of filtered companies to help set the toggle all checkbox state */
  protected filteredSubCache: SubApplicationsAttributes[] = [];

  /** flags to set the toggle all checkbox state */
  isIndeterminateSub = false;
  isCheckedSub = false;

  //action requeriments
  listRequirements: any[] = [] //TODO
  openFormAdd = false



  routeList: SubRouteAttributes[] = [];
  /** control for the selected masterUser for multi-selection */
  public routeMultiCtrl: FormControl<any[]> =
    new FormControl<any[]>([]);

  public routeMultiFilterCtrl: FormControl<string> =
    new FormControl<string>("");

  /** list of routeArea filtered by search keyword */
  public filteredRoute: ReplaySubject<SubRouteAttributes[]> =
    new ReplaySubject<SubRouteAttributes[]>(1);

  /** local copy of filtered routeArea to help set the toggle all checkbox state */
  protected filteredRouteCache: SubRouteAttributes[] = [];



  routeGroupList: RouteGroupAttributes[] = [];
  /** control for the selected masterUser for multi-selection */
  public routeGroupMultiCtrl: FormControl<any[]> =
    new FormControl<any[]>([]);

  public routeGroupMultiFilterCtrl: FormControl<string> =
    new FormControl<string>("");

  /** list of routeArea filtered by search keyword */
  public filteredGroupRoute: ReplaySubject<RouteGroupAttributes[]> =
    new ReplaySubject<RouteGroupAttributes[]>(1);

  /** local copy of filtered routeArea to help set the toggle all checkbox state */
  protected filteredGroupRouteCache: RouteGroupAttributes[] = [];

  salesOfficesMultiCtrl = new FormControl([]);
  salesOfficeList: SalesOfficeAttributes[] = [];
  listFilterSalesOfficeList: SalesOfficeAttributes[] = [];
  searchOfficeControl = new FormControl('');

  formAddList = {
    id: null,
    action: '',
    haveExternalTransaction: '',
    haveTrip: '',
    haveExternalTrip: '',
    applications: [],
    statusIds: [],
    statusERPIds: [],
    isEditMode: false
  }

  listAction = Object.values(ActionRequirementEnum)

  listOptionConditional: { code: boolean | string, value: string }[] = [
    { code: true, value: 'SI' },
    { code: false, value: 'NO' },
    { code: 'null', value: 'OMITIR' },
  ];

  listApplications = Object.keys(ActionApplicationEnum)

  orderStatusAveList: { id: number, name: string }[] = [
    { id: 1, name: 'Activo' },
    { id: 0, name: 'Anulado' },
    { id: 18, name: 'Inactivo por falta de inventario' },
    { id: 6, name: 'En progreso' },
    { id: 9, name: 'Entregado al/por cliente' },
    { id: 10, name: 'Entregado parcialmente al/por cliente' },
    { id: 11, name: 'No entregado al/por cliente' },
    { id: 7, name: 'Aprobado' },
    { id: 14, name: 'Aprobado parcialmente' },
    { id: 8, name: 'Rechazado' },
    { id: 17, name: 'Finalizado' },
  ]

  orderStatusErpList: { id: number, name: string }[] = [
    { id: 0, name: 'Pendiente envío a ERP' },
    { id: 4, name: 'Error enviando a ERP' },
    { id: 6, name: 'Error en ERP' },
    { id: 1, name: 'Enviado a ERP' },
    { id: 2, name: 'Recibido por ERP' },
    { id: 5, name: 'Mod. pendiente de replicar' },
    { id: 3, name: 'Creado en ERP' },
  ]

  //BUSCADOR
  searchSubscription: Subscription;

  selectedStatuses: [] = [];
  form: FormGroup;

  // Lazy loading flags
  loadFiltersData = false;

  documentLinesList: DocumentDetailClassAttributes[] = [];
  
  constructor(
    private readonly documentClassService: DocumentClassService,
    private readonly applicationService: ApplicationService,
    private readonly ordersCreationService: OrdersCreationService,
    private companyService: CompanyService,
    private documentTypeService: DocumentTypeService,
    private paymentConditionService: PaymentConditionService,
    private expeditionConditionService: ExpeditionConditionService,
    private subRouteService: SubRouteService,
    private routeGroupService: RouteGroupService,
    private readonly searchService: SearchService,
    private readonly salesOfficeService: SalesOfficeService,  
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private cdr: ChangeDetectorRef,
    private fb: FormBuilder,
    private readonly documentLineClassService: DocumentLineClassService
  ) { 
    this.form = this.fb.group({
          companyId: [null],
          documentTypeId: [[]]
        });
  }

  ngAfterViewInit(): void {
    this.onHandleSearch();
    this.setupPaginationAndSorting();
    this.findAllWithCount();
  }

  getListDocumentsLines(): void {
      let options: IPagination<DocumentDetailClassAttributes> = {
        currentPage: 1,
        limitPerPage: 100,
        sort: "name",
        sortDirection: "DESC",
      };
  
      let filter: IFilters = {
        companyId: this.form.get("companyId")?.value
      };
  
      this.documentLineClassService
        .findAllWithCount(options, filter)
        .subscribe({
          next: (res: IPaginationResult<DocumentDetailClassAttributes>) => {
            this.documentLinesList = res?.data?.[0]?.data ?? [];
          },
          error: (err) => {
            this.snackBar.open(
              err.error.message || "Error al obtener tipos de línea",
              "Cerrar",
              { duration: 5000 }
            );
          },
        })
    }

    
  onToggleApplyToAllRoutes() {
    if (this.currentCreateDocumentClass.applyToAllSubRoutes) {
      this.routeMultiCtrl.reset();
      this.routeMultiCtrl.disable();
    } else {
      this.routeMultiCtrl.enable();
    }
  }

  onToggleApplyToAllRoutesUpdate() {
    if (this.currentUpdateDocumentClass.applyToAllSubRoutes) {
      // this.routeMultiCtrl.reset();
      this.routeMultiCtrl.disable();
    } else {
      this.routeMultiCtrl.enable();
    }
  }

  onToggleApplyToGroupRoutes() {
    if (this.currentCreateDocumentClass.applyToSubRouteGroup) {
      this.routeGroupMultiCtrl.enable();
      this.routeGroupMultiCtrl.reset();
      this.routeMultiCtrl.reset();
      this.routeMultiCtrl.disable();
      this.currentCreateDocumentClass.applyToAllSubRoutes = true;
    } else {
      this.routeGroupMultiCtrl.enable();
      this.routeMultiCtrl.enable();
    }
  }

  onToggleApplyToGroupRoutesUpdate() {
    if (this.currentUpdateDocumentClass.applyToSubRouteGroup) {
      this.routeGroupMultiCtrl.enable();
      this.routeMultiCtrl.reset();
      this.routeMultiCtrl.disable();
    } else {
      this.routeGroupMultiCtrl.enable();
      this.routeMultiCtrl.enable();
    }
  }

  onToggleApplyToAllSalesOffice(){
    const docClass = this.id ? this.currentUpdateDocumentClass: this.currentCreateDocumentClass;
    if (docClass.applyToAllSalesOffices) {
      this.salesOfficesMultiCtrl.setValue([]);
    }
  }

  public handleFilterClean() {
    this.form.reset({
      documentTypeId: [[]]
    });

    this.selectedStatuses = [];

    this.findAllWithCount();
  }

  private fetchRoute(): void {
    if(this.currentCreateDocumentClass){
      this.currentUpdateDocumentClass=null;
    }
    this.subRouteService.findToComboBoxByModel("08").subscribe((res) => {
      this.routeList = res.data;
      this.filteredRoute.next(this.routeList);

        this.filteredRoute.pipe(take(1)).subscribe((routes) => {
          const selectedMaterials = routes.filter((route) =>
            this.currentUpdateDocumentClass?.applyToTheseSubRouteIds
              .map((r) => r)
              .includes(route._id.toString())
          );
          this.routeMultiCtrl.setValue(selectedMaterials.map(route => route));
        });
      // listen for search field value changes
      this.routeMultiFilterCtrl.valueChanges
        .pipe(takeUntil(this._onDestroy))
        .subscribe(() => {
          this.filterRouteGroupMulti();
        });
    });
  }

  protected filterRouteGroupMulti() {
    if (!this.routeList) {
      return;
    }
    // get the search keyword
    let search = this.routeMultiFilterCtrl.value;
    if (!search) {
      this.filteredRouteCache = this.routeList;
      this.filteredRoute.next(this.routeList);
      return;
    } else {
      search = search.toLowerCase();
    }
    // Filtrar las rutas por nombre o código
    this.filteredRouteCache = this.routeList.filter((material) => {
      const nameMatches = material.name.toLowerCase().indexOf(search) > -1;
      const codeMatches =
        material.externalKeys?.code?.toLowerCase().indexOf(search) > -1;
      return nameMatches || codeMatches; // Devolver true si coincide con el nombre o el código
    });
    this.filteredRoute.next(this.filteredRouteCache);
  }


  private fetchGroupRoute(): void {
    if(this.currentCreateDocumentClass){
      this.currentUpdateDocumentClass=null;
    }
    this.routeGroupService.findToComboBox().subscribe((res) => {
      this.routeGroupList = res.data;
      this.filteredGroupRoute.next(this.routeGroupList);

        this.filteredGroupRoute.pipe(take(1)).subscribe((routes) => {
          const selectedMaterials = routes.filter((route) =>
            this.currentUpdateDocumentClass?.applyToTheseSubRouteGroup
              .map((r) => r)
              .includes(route._id.toString())
          );
          this.routeGroupMultiCtrl.setValue(selectedMaterials.map(route => route));
        });
      // listen for search field value changes
      this.routeGroupMultiFilterCtrl.valueChanges
        .pipe(takeUntil(this._onDestroy))
        .subscribe(() => {
          this.filteredRouteGroupMulti();
        });
    });
  }

  protected filteredRouteGroupMulti() {
    if (!this.routeGroupList) {
      return;
    }
    // get the search keyword
    let search = this.routeGroupMultiFilterCtrl.value;
    if (!search) {
      this.filteredGroupRouteCache = this.routeGroupList;
      this.filteredGroupRoute.next(this.routeGroupList);
      return;
    } else {
      search = search.toLowerCase();
    }
    // Filtrar las rutas por nombre o código
    this.filteredGroupRouteCache = this.routeGroupList.filter((material) => {
      const nameMatches = material.name.toLowerCase().indexOf(search) > -1;
      const codeMatches =
        material.externalKeys?.code?.toLowerCase().indexOf(search) > -1;
      return nameMatches || codeMatches; // Devolver true si coincide con el nombre o el código
    });
    this.filteredGroupRoute.next(this.filteredGroupRouteCache);
  }



  private fetchAllApplication(): void {
    this.companyService.findToComboBox().subscribe({
      next: (res) => {
        this.companyList = res.data;
        this.filteredCompany.next(this.companyList);
        if (this.currentUpdateDocumentClass?.companies) {
          this.filteredCompany.pipe(take(1)).subscribe((materials) => {
            const selectedMaterials = materials.filter((material) =>
              this.currentUpdateDocumentClass.companies
                .map((r) => r._id.toString())
                .includes(material._id.toString())
            );
            this.companyMultiCtrl.setValue(selectedMaterials);
          });
        }
        // listen for search field value changes
        this.companyMultiFilterCtrl.valueChanges
          .pipe(takeUntil(this._onDestroy))
          .subscribe(() => {
            this.filterVisitMulti();
            this.setToggleAllCheckboxStateVisit();
          });
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener aplicaciones.","Cerrar",{ duration: 5000});
      },
    });
  }

  protected filterVisitMulti() {
    if (!this.companyList) {
      return;
    }
    // get the search keyword
    let search = this.companyMultiFilterCtrl.value;
    if (!search) {
      this.filteredCompanyCache = this.companyList;
      this.filteredCompany.next(this.companyList);
      return;
    } else {
      search = search.toLowerCase();
    }
    // Filtrar las rutas por nombre o código
    this.filteredCompanyCache = this.companyList.filter((material) => {
      const nameMatches = material.name.toLowerCase().indexOf(search) > -1;
      return nameMatches; // Devolver true si coincide con el nombre o el código
    });
    this.filteredCompany.next(this.filteredCompanyCache);
  }

  toggleSelectAll(selectAllValue: boolean) {
    this.filteredCompany
      .pipe(take(1), takeUntil(this._onDestroy))
      .subscribe((val) => {
        if (selectAllValue) {
          this.companyMultiCtrl.patchValue(val);
        } else {
          this.companyMultiCtrl.patchValue([]);
        }
      });
  }
  protected setToggleAllCheckboxStateVisit() {
    let filteredLength = 0;
    if (this.companyMultiCtrl && this.companyMultiCtrl.value) {
      this.filteredCompanyCache.forEach((el) => {
        if (this.companyMultiCtrl.value.indexOf(el) > -1) {
          filteredLength++;
        }
      });
      this.isIndeterminate =
        filteredLength > 0 && filteredLength < this.filteredCompanyCache.length;
      this.isChecked =
        filteredLength > 0 &&
        filteredLength === this.filteredCompanyCache.length;
    }
  }

  private fetchAllDocument(): void {
    this.documentClassService.findToComboBox().subscribe({
      next: (res) => {
        this.documentList = res.data;
        this.filteredDocument.next(this.documentList);
        if (this.currentUpdateDocumentClass?.nextDocumentClassCodes) {
          this.filteredDocument.pipe(take(1)).subscribe((materials) => {
            const selectedMaterials = materials.filter((material) =>
              this.currentUpdateDocumentClass.nextDocumentClassCodes.includes(
                material.code
              )
            );
            this.documentMultiCtrl.setValue(selectedMaterials);
          });
        }
        // listen for search field value changes
        this.documentMultiFilterCtrl.valueChanges
          .pipe(takeUntil(this._onDestroy))
          .subscribe(() => {
            this.filterDocumentMulti();
            this.setToggleAllCheckboxStateDocument();
          });
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener clases de documentos.","Cerrar",{ duration: 5000});
      },
    });
  }

  protected filterDocumentMulti() {
    if (!this.documentList) {
      return;
    }
    // get the search keyword
    let search = this.documentMultiFilterCtrl.value;
    if (!search) {
      this.filteredDocumentCache = this.documentList;
      this.filteredDocument.next(this.documentList);
      return;
    } else {
      search = search.toLowerCase();
    }
    // Filtrar las rutas por nombre o código
    this.filteredDocumentCache = this.documentList.filter((material) => {
      const nameMatches = material.name.toLowerCase().indexOf(search) > -1;
      return nameMatches; // Devolver true si coincide con el nombre o el código
    });
    this.filteredDocument.next(this.filteredDocumentCache);
  }

  toggleSelectAllDoc(selectAllValue: boolean) {
    this.filteredDocument
      .pipe(take(1), takeUntil(this._onDestroy))
      .subscribe((val) => {
        if (selectAllValue) {
          this.documentMultiCtrl.patchValue(val);
        } else {
          this.documentMultiCtrl.patchValue([]);
        }
      });
  }
  protected setToggleAllCheckboxStateDocument() {
    let filteredLength = 0;
    if (this.documentMultiCtrl && this.documentMultiCtrl.value) {
      this.filteredDocumentCache.forEach((el) => {
        if (this.documentMultiCtrl.value.indexOf(el) > -1) {
          filteredLength++;
        }
      });
      this.isIndeterminateDoc =
        filteredLength > 0 &&
        filteredLength < this.filteredDocumentCache.length;
      this.isCheckedDoc =
        filteredLength > 0 &&
        filteredLength === this.filteredDocumentCache.length;
    }
  }

  getAllSalesOfficeList(): void {
    this.searchOfficeControl.valueChanges.subscribe(value => {
      this.changueOptionsSalesOffice(value);
    });

    this.salesOfficeService.findToComboBox().subscribe({
      next: (res) => {
        this.salesOfficeList = res.data;
        this.listFilterSalesOfficeList = this.salesOfficeList.slice();

        const selectedOfficeIds = this.currentUpdateDocumentClass?.applyToTheseSalesOffices ?? [];

        const selectedOffices = this.salesOfficeList.filter((sale) =>
          selectedOfficeIds.includes(String(sale._id))
        );
        this.salesOfficesMultiCtrl.setValue(selectedOffices.map(route => route));
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error fetching sales office","Cerrar",{ duration: 5000});
      },
    });
  }
  
  changueOptionsSalesOffice(event){
    if (!this.salesOfficeList) {
      return;
    }
    let search = event;
    if (!search) {
      this.listFilterSalesOfficeList = this.salesOfficeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    this.listFilterSalesOfficeList = this.salesOfficeList.filter(item => item.externalKeys?.code?.toLowerCase().indexOf(search) > -1 || item.name.toLowerCase().indexOf(search) > -1)
  }

  private initializeCreateDocumentClass(): ICreateDocumentClass {
    return {
      code: "",
      excode: "",
      name: "",
      companyIds: [],
      subAppsThatCanCreateThisIds: [],
      nextDocumentClassCodes: [],
      keepsPricesOfSourceTransaction: false,
      makesStockReservation: false,
      keepPricingConditionsInDraft: false,
      keepQuotedPrices: false,
      makesStockValidation: false,
      canAddItemsFromOfSourceTransaction: false,
      keepPricesCopyingTransaction: false,
      canAddItemsWhenCopyingTransaction: false,
      showCurrentStockForMaterials: false,
      isDeliveryRouteRequired: false,
      showCurrentStockForMaterialsInPrinting: false,
      removeLeftZerosOfMaterial: false,
      automaticallyAssignedATrip: false,
      hasExternalInvoice: false,
      documentTypeId: null,
      documentTypeCode: null,
      paymentConditionId: null,
      expeditionConditionId: null,
      keepsQuotedOfSourceTransaction: null,
      materialBundlesBehaviour: null,
      canCreateOrderOverCreditLimit: OverCreditLimitEnum.IGNORE, // Ignorar límite de crédito
      canCreateOrderoOverdueInvoice: OverCreditLimitEnum.IGNORE, // Ignorar facturas vencidas
      recalcPriceForUnpricedUoM: RecalculatePriceEnum.RECALCULATE_QUANTITY, // Recalcular cantidad
      numberOfRequiredApprovals: 1,
      approvedRequestRequired: false,
      applyToAllSubRoutes: true,
      applyToTheseSubRouteIds: [],
      applyToSubRouteGroup: false,
      applyToTheseSubRouteGroup: [],
      activateBonusWithoutStock: false,
      allowCreditForOverdueInvoices: false,
      enableDraftOrder: false,
      applyToAllSalesOffices: true,
      applyToTheseSalesOffices: [],
      isDirectSalesDelivery: false,
      allowManualBonus: false,
      allowBonusOnDeliveryRejection: false,
      appliesForInventoryDistribution: false,
    };
  }

  private fetchAllDocumentType(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.documentTypeService.findToComboBox().subscribe({
        next: (res) => {
          this.documentTypeList = res.data;
          resolve();
        },
        error: (err) => {
          this.snackBar.open(err.error.message || "Error al obtener tipos de documentos.", "Cerrar", { duration: 5000 });
          reject(err);
        }
      });
    });
  }

  private fetchAllPaymentCondition(): void {
    this.paymentConditionService.findToComboBox().subscribe({
      next: (res) => {
        this.paymentConditionList = res.data;
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener condiciones de pago.","Cerrar",{ duration: 5000});
      },
    });
  }

  private fetchAllConditionExp(): void {
    this.expeditionConditionService.findToComboBox().subscribe({
      next: (res) => {
        this.expeditionConditionList = res.data;
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener condiciones.","Cerrar",{ duration: 5000});
      },
    });
  }

  private getApplications(): void {
    this.ordersCreationService.getApplications().subscribe({
      next: (res) => {
        this.applicationList = res;
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener aplicaciones.","Cerrar",{ duration: 5000});
      },
    });
  }

  compareFn = (option: any, value: any): boolean => {//para subapps
    return option?.parentId === value?.parentId && option?.subId === value?.subId;
  };

  compareFnClass = (id1: string, id2: string): boolean => {
    return id1?.toString() === id2?.toString();
  };

  getQuotedLabel(quoted: number): string {
    const labels = {
      [KeepQuotedEnum.KEEP_QUANTITY]: 'Mantiene cantidad',
      [KeepQuotedEnum.ALLOW_REDUCE_QUANTITY]: 'Permite bajar cantidad',
      [KeepQuotedEnum.ALLOW_INCREASE_QUANTITY]: 'Permite subir cantidad',
      [KeepQuotedEnum.ALLOW_REDUCE_INCREASE_QUANTITY]: 'Permite bajar y subir cantidad',
      [KeepQuotedEnum.ALLOW_DELETE_INCREASE_QUANTITY ]: 'Permite eliminar y subir cantidad'
    };
    return labels[quoted] || String(quoted);
  }


  bundleLabels = {
    [MaterialBundlesBehaviourEnum.RESTRICTIVE]: 'Restrictivo (No permite mezclar materiales)',
    [MaterialBundlesBehaviourEnum.PERMISSIVE]: 'Permisivo (Separa pedido por lista de precio)',
    [MaterialBundlesBehaviourEnum.IGNORE]: 'Ignorar (Separa pedido por ventana horaria)'
  }

  //requeriments
  getActionLabel(action: string): string {
    const labels = {
      [ActionRequirementEnum.SYNC]: 'Sincronizar',
      [ActionRequirementEnum.EDIT]: 'Editar',
      [ActionRequirementEnum.GENERATE_NEXT]: 'Generar siguiente documento',
      [ActionRequirementEnum.APPROVE]: 'Aprobar',
      [ActionRequirementEnum.APPROVE_GENERATE_NEXT]: 'Aprobar y generar siguiente documento directamente',
      [ActionRequirementEnum.REJECT]: 'Rechazar',
      [ActionRequirementEnum.ANNUL]: 'Anular',
      [ActionRequirementEnum.COPY]: 'Copiar',
      [ActionRequirementEnum.DIVIDE]: 'Dividir',
      [ActionRequirementEnum.JOIN]: 'Unificar',
      [ActionRequirementEnum.RELEASE]: 'Liberar'
    };
    return labels[action] || action;
  }

  getOverCreditLimitLabel(overCreditLimit: number): string {
    const labels = {
      [OverCreditLimitEnum.RESTRICTIVE]: 'Restrictivo (no se permite crear documento)',
      [OverCreditLimitEnum.PERMISSIVE]: 'Permisivo (sólo se muestra advertencia)',
      [OverCreditLimitEnum.IGNORE]: 'Ignorar límite de crédito',
    };
    return labels[overCreditLimit] || String(overCreditLimit);
  }

   getOverOrderInvoiceLabel(overOrderInvoice: number): string {
    const labels = {
      [OverCreditLimitEnum.RESTRICTIVE]: 'Restrictivo (no se permite crear documento)',
      [OverCreditLimitEnum.PERMISSIVE]: 'Permisivo (sólo se muestra advertencia)',
      [OverCreditLimitEnum.IGNORE]: 'Ignorar límite de crédito',
    };
    return labels[overOrderInvoice] || String(overOrderInvoice);
  }

  getRecalcPriceLabel(recalcPrice: number): string {
    const labels = {
      [RecalculatePriceEnum.NOT_ALLOW]: 'No permite seleccionar unidad sin precio',
      [RecalculatePriceEnum.RECALCULATE_PRICE]: 'Recalcula precio basado en unidad con precio',
      [RecalculatePriceEnum.RECALCULATE_QUANTITY]: 'Recalcula cantidad de unidad con precio basado en unidad seleccionada',
    };
    return labels[recalcPrice] || String(recalcPrice);
  }

  getListActionRequeriment() {
    if (Array.isArray(this.currentUpdateDocumentClass.actionsRequirements)) {
      this.listRequirements = this.currentUpdateDocumentClass.actionsRequirements?.map((action) => {
        return {
          ...action,
          haveExternalTransaction: action.haveExternalTransaction == null ? 'null' : action.haveExternalTransaction,
          haveExternalTrip: action.haveExternalTrip == null ? 'null' : action.haveExternalTrip,
          haveTrip: action.haveTrip == null ? 'null' : action.haveTrip,
          isEditMode: false,
        };
      });
    }
    this.cdr.detectChanges();
  }

  resetFormAddList() {
    this.formAddList = {
      id: null,
      action: '',
      haveExternalTransaction: '',
      haveTrip: '',
      haveExternalTrip: '',
      applications: [],
      statusIds: [],
      statusERPIds: [],
      isEditMode: false
    }
  }

  getDisabledActions() {
    return this.listRequirements.map(req => req.action);
  }

  onAddToListRAdd() {
    if (!this.formAddList.action || this.formAddList.haveExternalTransaction == null || this.formAddList.haveExternalTrip == null || this.formAddList.haveTrip == null ||
      this.formAddList.applications.length <= 0 || this.formAddList.statusIds.length <= 0) {
      this.snackBar.open("Faltan campos a seleccionar", "Cerrar", { duration: 3000, });
      return;
    }

    this.openFormAdd = false
    let aux = Object.assign(this.formAddList, {})
    this.listRequirements.unshift(
      aux
    )
    this.resetFormAddList()
  }

  updateAction(result): void {
    result.isEditMode = true;
  }

  onSaveAction(result, i): void {
    result.isEditMode = false;
    let auxData = this.listRequirements.slice()
    auxData.splice(i, 1, result)
    this.listRequirements = auxData
    //this.snackBar.open('Registro actualizado con éxito', 'Cerrar', { duration: 3000 });
    this.cdr.detectChanges()
  }

  onDeleteToListAction(element, i) {
    let auxData = this.listRequirements.slice()
    auxData.splice(i, 1)
    this.listRequirements = auxData
    //this.snackBar.open('Registro actualizado con éxito', 'Cerrar', { duration: 3000 });
    this.cdr.detectChanges()
  }

  getFinalActionReq() {
    return this.listRequirements.map(ele => {
      return {
        action: ele.action,
        haveTrip: ele.haveTrip === 'null' ? null : ele.haveTrip,
        haveExternalTrip: ele.haveExternalTrip === 'null' ? null : ele.haveExternalTrip,
        haveExternalTransaction: ele.haveExternalTransaction === 'null' ? null : ele.haveExternalTransaction,
        applications: ele.applications,
        statusIds: ele.statusIds,
        statusERPIds: ele.statusERPIds
      };
    });
  }

  //end requeriments
  private setupPaginationAndSorting(): void {
    this.paginator.page.subscribe(() => this.findAllWithCount());
    this.sort.sortChange.subscribe(() => {
      this.paginator.pageIndex = 0;
      this.findAllWithCount();
    });
  }

  findAllWithCount(): void {
    const pageIndex = this.paginator.pageIndex + 1;
    const sortField = this.getSortField();
    const sortDirection: "ASC" | "DESC" =
      this.sort.direction ? this.sort.direction.toUpperCase() === "ASC" ? "ASC" : "DESC" : "ASC";
    //   const companyCodes = this.getSelectedCompanyCodes(this.selectedCompanyIds);

    this.documentClassService
      .findAllWithCount({
        currentPage: pageIndex,
        limitPerPage: this.pageSize,
        search: this.searchQuery,
        sort: sortField,
        sortDirection: sortDirection,
      },
      this.form.get("companyId").value,
      this.selectedStatuses,
      this.form.get("documentTypeId").value
    )
      .subscribe((data) => {
        this.dataSource = data?.data?.[0]?.data ?? [];
        this.totalItems = data?.data?.[0]?.pageInfo?.[0]?.total ?? 0;
        this.paginator.length = this.totalItems;
      });
  }

  private getSortField(): keyof DocumentClassAttributes {
    const validSortFields: (keyof DocumentClassAttributes)[] = [
      "name",
      "documentType.name" as keyof DocumentClassAttributes,
      "position",
      "statusId",
    ];
    return validSortFields.includes(
      this.sort.active as keyof DocumentClassAttributes
    )
      ? (this.sort.active as keyof DocumentClassAttributes)
      : "name";
  }

  onPageChange(event: PageEvent): void {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.findAllWithCount();
  }

  onSearchChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.searchQuery = input.value.trim();
    if (this.searchQuery.length >= 2 || this.searchQuery.length === 0) {
      this.paginator.pageIndex = 0;
      this.findAllWithCount();
    }
  }

  public onHandleSearch(){
    this.searchSubscription = this.searchService.searchTerm$
      .subscribe(term => {
        this.searchQuery = term;
        if (this.searchQuery.length >= 2 || this.searchQuery.length === 0) {
          this.paginator.pageIndex = 0;
          this.findAllWithCount();
        }
      });
  }

  onFilterPanelOpened(): void {
    this.loadFiltersData = true;
  }

  trackByFn(index: number, item: DocumentClassAttributes): string {
    return item._id.toString();
  }

  openCreateModal(): void {
    this.fetchAllPaymentCondition();
    this.fetchAllConditionExp();
    this.fetchAllDocumentType();
    this.fetchAllDocument();
    this.fetchAllApplication();
    this.getApplications();
    this.fetchGroupRoute();
    this.fetchRoute();
    this.getAllSalesOfficeList();
    this.getListDocumentsLines();

    
    this.subMultiCtrl.setValue([]);
    
    this.currentCreateDocumentClass = this.initializeCreateDocumentClass();
    this.listRequirements = []
    this.dialogRefAdd = this.dialog.open(this.addModal, { width: '90%', disableClose: true })
    // this.dialogRefAdd.afterClosed().subscribe((result) => result && this.createDocumentClass());
    this.dialogRefAdd.afterClosed().subscribe((result) => { result });
  }

  async openEditModal(condition: DocumentClassAttributes): Promise<void> {
    this.id = true;
    await this.fetchAllDocumentType();
    this.getApplications();
    this.fetchAllPaymentCondition();
    this.fetchAllConditionExp();
    this.fetchAllDocument();
    this.fetchAllApplication();
    this.fetchGroupRoute();
    this.fetchRoute();
    this.getAllSalesOfficeList();
    this.getListDocumentsLines();

    const selectedPaymentCondition = condition.paymentCondition?._id
      ? this.paymentConditionList.find(
        (payment) => payment._id === condition.paymentCondition._id
      )
      : null;

    const selectedConditionExpedition = condition.expeditionCondition?._id
      ? this.expeditionConditionList.find(
        (payment) => payment._id === condition.expeditionCondition._id
      )
      : null;

    const mappedAllowedLineClasses = condition.allowedLineClasses?.map(lc => lc._id.toString()) ?? [];
    this.allowedLineClassesCtrl.setValue(mappedAllowedLineClasses);

    this.currentUpdateDocumentClass = {
      ...condition,
      externalKeys: {
        code: condition?.externalKeys?.code ?? null,
      },
      paymentCondition: selectedPaymentCondition || condition.paymentCondition,
      expeditionCondition:
        selectedConditionExpedition || condition.expeditionCondition,
      actionsRequirements: condition.actionsRequirements,
      numberOfRequiredApprovals: condition.numberOfRequiredApprovals ?? 1,
      approvedRequestRequired: condition.approvedRequestRequired ?? false,
      canCreateOrderOverCreditLimit: condition.canCreateOrderOverCreditLimit ?? OverCreditLimitEnum.IGNORE,
      canCreateOrderoOverdueInvoice: condition.canCreateOrderoOverdueInvoice ?? OverCreditLimitEnum.IGNORE,
      recalcPriceForUnpricedUoM: condition.recalcPriceForUnpricedUoM ?? RecalculatePriceEnum.RECALCULATE_QUANTITY,
      activateBonusWithoutStock: condition.activateBonusWithoutStock ?? false,
      enableDraftOrder: condition.enableDraftOrder ?? false,
      applyToAllSalesOffices : condition.applyToAllSalesOffices ?? false,
      allowManualBonus: condition.allowManualBonus ?? false,
      allowBonusOnDeliveryRejection: condition.allowBonusOnDeliveryRejection ?? false,
      appliesForInventoryDistribution: condition.appliesForInventoryDistribution ?? false,
    };
    this.currentUpdateDocumentClass.applyToAllSubRoutes ??= true;
    this.currentUpdateDocumentClass.applyToSubRouteGroup ??= true;
    this.currentUpdateDocumentClass.allowedLineClasses = condition.allowedLineClasses;
    this.getListActionRequeriment()
    
    if(this.currentUpdateDocumentClass.documentType){
      this.onDocumentTypeSelectionChange(this.currentUpdateDocumentClass, String(this.currentUpdateDocumentClass.documentType._id), true)
    }

    const mappedSubApplications = condition?.subAppsThatCanCreateThis?.map((subId: ShortSubApplicationsAttributes) => {
      return subId._id ?? null;
    }).filter(item => item !== null);

    this.subMultiCtrl.setValue(mappedSubApplications)
    this.dialogRefEdit = this.dialog.open(this.editModal, { width: '90%', disableClose: true })
    // this.dialogRefEdit.afterClosed().subscribe((result) => result && this.updateDocumentClass(condition._id.toString()));
    this.dialogRefEdit.afterClosed().subscribe((result) => { result });
  }

  resetFormControls(): void {
    this.companyMultiCtrl.reset();
    this.documentMultiCtrl.reset();
    this.routeGroupMultiCtrl.reset();
    this.routeMultiCtrl.reset(); 
  }

  onAllowedLineClassesChange(selectedIds: string[]): void {
    this.currentCreateDocumentClass.allowedLineClassesIds = selectedIds;
  }

  createDocumentClass(): void {
    this.currentCreateDocumentClass.companyIds =
      this.companyMultiCtrl.value.map((ware: CompanyAttributes) =>
        ware._id.toString()
      );
    this.currentCreateDocumentClass.nextDocumentClassCodes =
      this.documentMultiCtrl.value?.map(
        (doc: DocumentClassAttributes) => doc.code
      );
    this.currentCreateDocumentClass.applyToTheseSubRouteIds = this.routeMultiCtrl.value?.map((rou: SubRouteAttributes) => rou?._id?.toString()) ?? undefined,
      this.currentCreateDocumentClass.applyToTheseSubRouteGroup = this.routeGroupMultiCtrl.value?.map((rou: RouteGroupAttributes) => rou?._id?.toString()) ?? undefined,

      this.currentCreateDocumentClass.subAppsThatCanCreateThisIds = this.subMultiCtrl?.value?.map((selection: any) => selection) || [];
    this.currentCreateDocumentClass.actionsRequirements = this.getFinalActionReq();

    this.currentCreateDocumentClass.applyToTheseSalesOffices = this.salesOfficesMultiCtrl.value?.map((sale: SalesOfficeAttributes) => sale?._id.toString()) ?? undefined

    const { documentTypeCode, ...currentCreateDocumentClass } = this.currentCreateDocumentClass;
    this.documentClassService
      .create(currentCreateDocumentClass)
      .subscribe({
        next: () => {
          this.snackBar.open("Registro creado con éxito", "Cerrar", {
            duration: 3000,
          });
          this.resetFormControls();
          this.findAllWithCount();
          this.dialogRefAdd.close();
        },
        error: (err) => {
          this.snackBar.open(
            err.error.message || "Error al crear el registro",
            "Cerrar",
            { duration: 3000 }
          );
        },
      });
  }

  updateDocumentClass(id: string): void {
    if (this.currentUpdateDocumentClass) {
      const updatedDocumentClass: IUpdateDocumentClass = {
        ...this.currentUpdateDocumentClass,
        excode: this.currentUpdateDocumentClass?.externalKeys?.code,
        allowedLineClassesIds: this.allowedLineClassesCtrl.value ?? [],
        companyIds:
          this.companyMultiCtrl.value?.map(
            (company: CompanyAttributes) => company._id?.toString() || null
          ) ?? null,

        nextDocumentClassCodes:
          this.documentMultiCtrl.value?.map(
            (doc: DocumentClassAttributes) => doc.code || null
          ) ?? null,

        applyToTheseSubRouteIds: this.routeMultiCtrl.value?.map((rou: SubRouteAttributes) => rou?._id?.toString()) ?? undefined,
        applyToTheseSubRouteGroup: this.routeGroupMultiCtrl.value?.map((rou: RouteGroupAttributes) => rou?._id?.toString()) ?? undefined,


        subAppsThatCanCreateThisIds: this.subMultiCtrl?.value?.map((selection: any) => selection) || [],
        actionsRequirements: this.getFinalActionReq(),
        documentTypeId: String(this.currentUpdateDocumentClass.documentType._id),
        applyToTheseSalesOffices: this.salesOfficesMultiCtrl.value?.map((sale: SalesOfficeAttributes) => sale?._id.toString()) ?? undefined
      };

      const { documentTypeCode, ...currentUpdateDocumentClass } = updatedDocumentClass;
      this.documentClassService.update(id, currentUpdateDocumentClass).subscribe({
        next: () => {
          this.snackBar.open("Registro actualizado con éxito", "Cerrar", {
            duration: 3000,
          });
          this.resetFormControls();
          this.findAllWithCount();
          this.dialogRefEdit.close();
        },
        error: (err) => {
          this.snackBar.open(
            err.error.message || "Error al actualizar el registro",
            "Cerrar",
            { duration: 3000 }
          );
        },
      });
    }
  }

  onStatusChange(event: boolean, condition: DocumentClassAttributes): void {
    const originalStatusId = condition.statusId;
    const updatedStatusId = event ? 1 : 0;
    const updatedDocumentClass: IUpdateDocumentClass = {
      statusId: updatedStatusId,
    };

    this.documentClassService
      .update(condition._id.toString(), updatedDocumentClass)
      .subscribe({
        next: () => {
          this.findAllWithCount();
        },
        error: () => {
          condition.statusId = originalStatusId; // Volver al estado original si falla
          this.snackBar.open("Error al actualizar el estado.", "Cerrar", {
            duration: 3000,
          });
          this.findAllWithCount();
        },
      });
  }

  onPaymentConditionSelectionChange(paymentConditionId: string): void {
    if (this.currentUpdateDocumentClass) {
      this.currentUpdateDocumentClass.paymentCondition =
        this.paymentConditionList.find(
          (payment) => payment._id.toString() === paymentConditionId
        )!;
    }
  }

  onDocumentTypeSelectionChange(docClass: any, documentTypeId: string, isInitialLoad: boolean = false) {
    const selected = this.documentTypeList.find(dt => String(dt._id) === documentTypeId);
    if (selected) {
      docClass.documentTypeId = selected._id;  
      docClass.documentType = selected; 
      docClass.documentTypeCode = selected.code;
      
      // IMPORTANTE: `enableDraftOrder` y `isDirectSalesDelivery` se establecen en `false` 
      // porque al seleccionar un tipo de documento, solo UNA clase puede tener estas opciones activadas.
      if(!isInitialLoad){
        docClass.enableDraftOrder = false;
        docClass.isDirectSalesDelivery = false;
      }
    }
  }

  onConditionExpeditionSelectionChange(conditionExpedition: string): void {
    if (this.currentUpdateDocumentClass) {
      this.currentUpdateDocumentClass.expeditionCondition =
        this.expeditionConditionList.find(
          (payment) => payment._id.toString() === conditionExpedition
        )!;
    }
  }

  openDeleteDialog(condition: DocumentClassAttributes): void {
    this.dialog
      .open(this.deleteDialog, {
        data: condition,
        panelClass: "delete-modal",
        disableClose: true,
      })
      .afterClosed()
      .subscribe((result) => result && this.delete(condition._id.toString()));
  }

  delete(id: string): void {
    this.documentClassService.remove(id).subscribe(() => {
      this.findAllWithCount();
      this.snackBar.open("Registro eliminado con éxito", "Cerrar", {
        duration: 3000,
      });
    });
  }

  compareById(item1: any, item2: any): boolean {
    return item1 && item2 ? item1._id === item2._id : item1 === item2;
  }

  //   onCompanySelectionChange(companyId: string): void {
  //     if (this.currentUpdateDocumentClass) {
  //       this.currentUpdateDocumentClass.company = this.companyList.find(
  //         (company) => company._id.toString() === companyId
  //       )!;
  //     }
  //   }

  //   getSelectedCompanyCodes(selectedCompanyIds: string[]): number[] {
  //     return selectedCompanyIds.map(
  //       (id) => this.companyList.find((group) => group._id.toString() === id)?.id
  //     );
  //   }

  clearFilters(): void {
    this.selectedCompanyIds = [];
    this.searchQuery = "";
    this.findAllWithCount();
  }

  ngOnDestroy(): void {
    this.searchSubscription.unsubscribe();
  }
}
